import { getFieldsSingleError } from '@utils/common';
import { notifyError } from '@utils/notifications';
import { UNKNOWN_ERROR_MESSAGE } from '@constants';

import { usePostDeleteMutation } from './gql/graphql.v5.generated';

interface SocialPostAuthor {
  id: number,
}

interface SocialPost {
  id: string,
  author: SocialPostAuthor,
}

export const useSocailPostDelete = (post: SocialPost) => {
  const [deletePost, { loading }] = usePostDeleteMutation({
    context: {
      v5: true,
    },
    update: (cache, result) => {
      if (!result.errors?.length) {
        const normalizedPostId = cache.identify({ id: post.id, __typename: 'PostType' });
        const normalizedUserId = cache.identify({ id: post.author.id, __typename: 'User' });

        cache.modify({
          id: normalizedUserId,
          fields: {
            postsAmount: (value) => {
              if (typeof value === 'number') {
                return value - 1;
              }
              return value;
            },
          },
        });

        cache.evict({ id: normalizedPostId });
        cache.gc();
      }
    },
  });

  const handleDeletePost = async () => {
    try {
      const response = await deletePost({ variables: { postId: post.id } });

      const errors = response.data?.postDelete.errors;

      if (errors?.length) {
        const error = getFieldsSingleError(errors);

        notifyError(Object.values(error)[0]);
      }

    } catch {
      notifyError(UNKNOWN_ERROR_MESSAGE());
    }
  };

  return {
    handleDeletePost,
    loading,
  };
};
